import { DatePipe, DecimalPipe, Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { EspecieEppoPopupComponent } from '../../../core/components/popup/especies/especieEppoPopup.component';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc, WBotanicaExtendedViewModel } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudCpeProductosViewModel, TwProductoCertificadoPrevioExViewModel } from './productosCpe.types';
import { SolicitudCpeService } from '../datosbasicos/cpe.service';
import { ProductosCpeService } from './productosCpe.service';

@Component({
    selector: 'app-productoscpe-edit',
    templateUrl: './productosCpe-edit.component.html',
})
export class ProductoCpeEditComponent extends ComponentBase implements OnInit {
    @ViewChild(EspecieEppoPopupComponent) private especieEppoPopupComponent: EspecieEppoPopupComponent;

    editMode = false;
    editTitle = 'Nuevo';
    codigoCpe: string;
    tituloEstadoSolicitud: string;
    IdEstadoSolicitudCpe: number;
    campoObligatorioPeso = false;
    campoObligatorioVolumen = false;
    campoObligatorioUnidades = false;

    listGrupo: Tc[];
    listForma: Tc[];
    listUnidadMedidaPeso: Tc[];

    IdEspecie: number;
    IdForma: number | null = 0;
    IdGrupo = 0;

    IdSolicitudCpe: number;

    solicitudCpeProductos: SolicitudCpeProductosViewModel;
    productoCpe: TwProductoCertificadoPrevioExViewModel;

    habilitarGuardar = true;
    habilitarEdicion = true;
    habilitarBusquedaEppo = false;
    visibilitySpinner = false;
    //eppoObligatorio: boolean = true;

    isCollapsedDatosBasicos = false;

    constructor(
        public datepipe: DatePipe,
        public decimalPipe: DecimalPipe,
        private activatedRoute: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private cpeService: SolicitudCpeService,
        private productoCpeService: ProductosCpeService,
        private _location: Location,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudCpeProductos = new SolicitudCpeProductosViewModel();
        this.productoCpe = new TwProductoCertificadoPrevioExViewModel();
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];
        let idprod = +this.activatedRoute.snapshot.params['idprod'];

        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
        });
        this.globalService.getUnidadMedidaPeso().subscribe(res => {
            this.listUnidadMedidaPeso = res;
        });

        this.IdSolicitudCpe = id;

        this.createForm();

        //Para que se abran las pestañas de la solicitud
        this.guardRefreshPage(id);

        //EDIT DE PRODUCTO
        if (idprod) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.productoCpeService.getProductoCpe(idprod).subscribe(result => {
                this.productoCpe = result;

                this.globalService.getFormasByGrupo(this.productoCpe.IdGrupo).subscribe(res => {
                    this.listForma = res;
                });

                this.IdEstadoSolicitudCpe = this.productoCpe.IdEstadoSolicitudCpe;
                this.codigoCpe = this.productoCpe.Codigo;
                this.tituloEstadoSolicitud = this.productoCpe.IdEstadoSolicitudCpeDescripcion;

                this.IdForma = this.productoCpe.IdForma;

                this.updateForm();

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_CPE,
                    this.productoCpe.IdEstadoSolicitudCpe,
                    undefined,
                ).Visible;
                this.habilitarEdicion = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_CPE,
                    this.productoCpe.IdEstadoSolicitudCpe,
                    undefined,
                ).Visible;

                this.habilitarBusquedaEppo = this.IdForma > 0 ? this.habilitarEdicion : false;

                if (!this.habilitarEdicion) {
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();
                }
            });
        } //FIN EDIT PRODUCTO

        //ALTA DE PRODUCTO
        else {
            this.productoCpeService.getSolicitudProductosCpe(id).subscribe(result => {
                this.solicitudCpeProductos = result;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_CPE,
                    this.solicitudCpeProductos.IdEstadoSolicitudCpe,
                    undefined,
                ).Visible;

                if (!this.habilitarGuardar) {
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();
                }

                this.IdEstadoSolicitudCpe = this.solicitudCpeProductos.IdEstadoSolicitudCpe;
                this.codigoCpe = this.solicitudCpeProductos.Codigo;
                this.tituloEstadoSolicitud = this.solicitudCpeProductos.IdEstadoSolicitudCpeDescripcion;
            });
        } //FIN DE ALTA DE PRODUCTO

        //Contenedores
        this.isCollapsedDatosBasicos = false;
    }

    guardRefreshPage(id: number): void {
        if ((id && !this.navMenuService.currentSolicitudCpe.Id) || this.navMenuService.currentSolicitudCpe.Id !== id) {
            this.cpeService.getSolicitudCpe(id).subscribe(result => {
                this.navMenuService.currentSolicitudCpe = result;
            });
        }
    }

    private DisableControlsConsulta(): void {
        this.form.controls['IdGrupo'].disable();
        this.form.controls['IdForma'].disable();
        this.form.controls['CodigoTaric'].disable();
        this.form.controls['CodigoEppo'].disable();
        this.form.controls['NombreBotanico'].disable();
        this.form.controls['NombreComun'].disable();
        //this.form.controls['IdParcelaAtestFito'].disable();
        this.form.controls['Peso'].disable();
        this.form.controls['IdUnidadMedidaPeso'].disable();
        this.form.controls['Volumen'].disable();
        this.form.controls['Unidades'].disable();
    }

    createForm(): void {
        this.form = this.fb.group({
            IdGrupo: [null, Validators.required],
            IdForma: [null, Validators.required],
            //IdParcelaAtestFito: null,
            CodigoTaric: [null, Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10)])],
            CodigoEppo: null,
            NombreBotanico: [null, Validators.required],
            NombreComun: [null, Validators.required],
            Peso: [0, Validators.compose([Validators.required, CustomValidator.DecimalTopCero])],
            //Peso: 0,
            IdUnidadMedidaPeso: [null, Validators.required],
            Volumen: null,
            Unidades: null,
        });
    }

    updateForm(): void {
        this.form.setValue({
            IdGrupo: this.productoCpe.IdGrupo,
            IdForma: this.productoCpe.IdForma,
            //IdParcelaAtestFito: this.productoAtestFito.IdParcelaAtestFito,
            CodigoTaric: this.productoCpe.CodigoTaric,
            CodigoEppo: this.productoCpe.CodigoEppo,
            NombreBotanico: this.productoCpe.IdBotanicaDescripcion,
            NombreComun: this.productoCpe.NombreComun,
            Peso: this.decimalPipe.transform(this.productoCpe.Peso, '1.3-3', 'es'),
            IdUnidadMedidaPeso: this.productoCpe.IdUnidadMedidaPeso,
            Volumen: this.decimalPipe.transform(this.productoCpe.Volumen, '1.3-3', 'es'),
            Unidades: this.productoCpe.Unidades,
        });

        this.IdEspecie = this.productoCpe.IdEspecie;
        this.IdGrupo = this.productoCpe.IdGrupo;
    }

    saveProducto(): void {
        this.visibilitySpinner = true;
        this.onSubmit();
    }

    onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            this.visibilitySpinner = false;
            this.addErrorMessage('Revise los datos del producto');

            this.isCollapsedDatosBasicos = false;

            return;
        }

        let pesoFormat = this.form.value.Peso != null ? this.form.value.Peso.replace('.', '').replace(',', '.') : this.form.value.Peso;
        let volumenFormat = this.form.value.Volumen != null ? this.form.value.Volumen.replace('.', '').replace(',', '.') : this.form.value.Volumen;

        let productoCpe = new TwProductoCertificadoPrevioExViewModel();

        //producto.CodigoEppo = this.form.value.CodigoEppo; **hay q obtener el 'IdEspecie'
        productoCpe.IdEspecie = this.IdEspecie;

        //producto.IdBotanicaDescripcion = this.form.value.NombreBotanico;
        productoCpe.NombreComun = this.form.value.NombreComun;
        productoCpe.CodigoTaric = this.form.value.CodigoTaric;
        productoCpe.Peso = pesoFormat;
        productoCpe.IdUnidadMedidaPeso = this.form.value.IdUnidadMedidaPeso;
        productoCpe.Volumen = volumenFormat;
        productoCpe.Unidades = this.form.value.Unidades;
        //productoCpe.IdParcelaAtestFito = this.form.value.IdParcelaAtestFito;

        productoCpe.IdCertPrevioEx = this.IdSolicitudCpe;
        productoCpe.Id = this.productoCpe.Id;

        if (this.editMode) {
            this.productoCpeService.editProductoCpe(productoCpe).subscribe({
                next: res => {
                    this.addSuccessMessage('Producto modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedDatosBasicos = false;
                },
            });
        } else {
            this.productoCpeService.createProductoCpe(productoCpe).subscribe({
                next: res => {
                    this.addSuccessMessage('Producto creado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedDatosBasicos = false;
                },
            });
        }
    }

    onAcceptDialogEspecieEppo(especieEppo: WBotanicaExtendedViewModel): void {
        this.form.patchValue({
            CodigoEppo: especieEppo.CodigoEppo,
            NombreBotanico: especieEppo.IdNombreCientificoDescripcion,
            NombreComun: especieEppo.NombreComun,
        });

        this.IdEspecie = especieEppo.Id;
    }

    onSelectGrupo(): void {
        const idGrupo = this.form.value.IdGrupo;

        this.form.patchValue({
            IdForma: null,
        });
        this.listForma = [];

        if (idGrupo != null) {
            this.globalService.getFormasByGrupo(idGrupo).subscribe(res => {
                this.listForma = res;
            });
        } else {
            this.onSelectForma();
        }
    }

    onSelectForma(): void {
        this.IdForma = this.form.value.IdForma;

        if (this.IdForma == null) {
            this.habilitarBusquedaEppo = false;
        } else {
            this.habilitarBusquedaEppo = true;
        }

        this.form.patchValue({
            CodigoEppo: '',
            NombreBotanico: '',
            NombreComun: '',
        });
    }

    onSearchCodigoEppo(): void {
        this.especieEppoPopupComponent.showDialog(this.form.controls['IdGrupo'].value, this.IdForma!, null, false);
    }

    onBack(): void {
        //this.router.navigate(["/importacion/solicitud/productos", this.IdSolicitud])
        //Usamos el location ya que hay diferentes formas de llegar aquí­
        this._location.back();
    }
}
